import * as React from 'react';
import { useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Stack, Switch } from '@mui/material';
import { useAccount } from '../account/AccountContext';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountAvatar from "../common/AccountAvatar";
import ResponsiveText from '../common/ResponsiveText';
import ConfirmDeactivateDialog from './ConfirmDeactivateDialog';
import { deactivateAccount, getProfile, updateEmailPreference } from '../../gateway/accounts';
import { useNavigate } from 'react-router-dom';
import { ROUTE_ACCOUNT_SETTINGS, ROUTE_LOGIN } from '../../UkloRoutes';

export default function LoggedInUser() {
  const { account, logout } = useAccount();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [receiveEmails, setReceiveEmails] = useState(true);
  const [deactivateDialogOpen, setDeactivateDialogOpen] = useState(false);

  useEffect(() => {
    if (account) {
      getProfile().then(p => setReceiveEmails(p.receiveEmails)).catch(() => {});
    }
  }, [account]);

  if (account === undefined) {
    return null;
  }

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggleEmails = () => {
    const newValue = !receiveEmails;
    setReceiveEmails(newValue);
    updateEmailPreference(newValue).catch(() => setReceiveEmails(!newValue));
  };

  const handleDeactivate = () => {
    setDeactivateDialogOpen(false);
    handleClose();
    deactivateAccount().then(() => {
      navigate(ROUTE_LOGIN);
      window.location.reload();
    });
  };

  return (
    <>
      <Stack direction="row" spacing={{xs: 0.5, md: 1}} alignItems="center">
        <IconButton onClick={handleOpen} size="small" sx={{ p: 0 }}>
          <AccountAvatar account={account} size="sm" />
        </IconButton>
        <ResponsiveText xs="" md={account.name} variant="body2" />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => { handleClose(); navigate(ROUTE_ACCOUNT_SETTINGS); }}>
            <ListItemIcon><ManageAccountsIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Account settings</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleToggleEmails}>
            <ListItemText>Email notifications</ListItemText>
            <Switch
              checked={receiveEmails}
              size="small"
              sx={{ ml: 1 }}
              onClick={e => e.stopPropagation()}
              onChange={handleToggleEmails}
            />
          </MenuItem>
          <MenuItem onClick={() => setDeactivateDialogOpen(true)}>
            <ListItemIcon><PersonOffIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Deactivate account</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); logout(); }}>
            <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Log out</ListItemText>
          </MenuItem>
        </Menu>
      </Stack>
      <ConfirmDeactivateDialog
        open={deactivateDialogOpen}
        onClose={() => setDeactivateDialogOpen(false)}
        onConfirm={handleDeactivate}
      />
    </>
  );
}
